import { Text } from "@otrium/atoms";
import { Flex } from "@otrium/core";
import styled from "@emotion/styled";
import { Button } from "src/atoms/Button";

const StyledProductOrder = styled.div`
  margin-top: ${({ theme }) => theme.space[5]}px;

  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: ${({ theme }) => theme.space.space16};
  }
`;

const SizeOption = styled(Text)`
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.tone.black};
`;

const MobileAddToCartFixed = styled(Flex)<{ isVisible?: boolean }>`
  flex-direction: column;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 200;
  padding: ${({ theme }) => theme.space[3]}px;
  background-color: ${({ theme }) => theme.colors.tone.white};
  box-shadow: 0px -4px 8px ${({ theme }) => theme.effects.overlay.black_10};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? "auto" : "none")};
  transform: translateY(${({ isVisible }) => (isVisible ? "0" : "100%")});
  transition: opacity 200ms linear, transform 200ms linear;
`;

const SelectSizeError = styled(Text)`
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.semantic.red};
`;

const StyledAddingToCartButton = styled(Button)`
  max-width: none !important;
  flex: 1 1 auto;
  width: auto;
`;

export {
  StyledProductOrder,
  SizeOption,
  MobileAddToCartFixed,
  SelectSizeError,
  StyledAddingToCartButton,
};
